<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormEncuestaOpcionBase" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                                <div class="row">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 text-center">
                                                        <label for="">Opciones por Defecto</label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 text-center">
                                                        <button v-show="!BloquearEdicion" @click="AgregarOpcion('opcion')" class="btn btn-primary"><i class="fa fa-plus"></i></button>
                                                    </div>
                                                </div>
                                                <div style="height:320px; overflow-y:auto; width:100%;">
                                                    <div class="row mb-3" v-for="(item,index) in OpcionesDefault" :key="index">
                                                        <div class="col-12 col-sm-12 col-lg-10">
                                                            <input :disabled="BloquearEdicion" placeholder="Agrega una Opción" type="text" class="form-control" v-model="item.Nombre">
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-lg-2">
                                                            <button @click="EliminarOpcion(index,'Default')" v-show="item.MostrarBorrar" class="btn btn-danger"><i class="fa fa-trash"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                                <div class="row">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 text-center">
                                                        <label for="">Opciones para Encuesta</label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 text-center">
                                                        <button v-show="!BloquearEdicion" @click="AgregarOpcion('encuesta')" class="btn btn-primary"><i class="fa fa-plus"></i></button>
                                                    </div>
                                                </div>
                                                <div style="height:320px; overflow-y:auto; width:100%;">
                                                    <div class="row mb-3" v-for="(item,index) in OpcionesEncuesta" :key="index">
                                                        <div class="col-12 col-sm-12 col-lg-10">
                                                            <input :disabled="BloquearEdicion" placeholder="Agrega una Opción" type="text" class="form-control" v-model="item.Nombre">
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-lg-2">
                                                            <button @click="EliminarOpcion(index,'Encuesta')" v-show="item.MostrarBorrar" class="btn btn-danger"><i class="fa fa-trash"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <CBtnSave :poBtnSave="oBtnSave"></CBtnSave>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template>
        </CList>
    </div>
</template>

<script>
const EmitEjecuta = 'seccionOpcionBase';
import Configs from '@/helpers/VarConfig.js';
export default {
    name:'FormEncuestaOpcionesBase',
    props:['Id','pIdioma','pCategoria','pAnio'],
    data() {
        return {
            ConfigList:{
                Title: 'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: 'Encuesta Opciones Base',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'opcionencuesta',
                EmitSeccion: EmitEjecuta,
            },

            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
            OpcionesDefault:[],
            OpcionesEncuesta:[],
            BloquearEdicion:false
        }
    },
    methods: {
        async Guardar(){
            this.oBtnSave.DisableBtn=true;
            let BndError=false;
            let Mensaje="";
            if (this.OpcionesDefault.length==0) {
                BndError=true;
                Mensaje="Debe Haber al Menos 1 Opción en las Opciones por Defecto"
            }
            else if (this.OpcionesEncuesta.length==0) {
                BndError=true;
                Mensaje="Debe Haber al Menos 1 Opción en las Opciones de la Encuesta"
            }
            this.OpcionesDefault.every((element)=>{
                if (element.Nombre=='') {
                    Mensaje="Ninguna Opción por Defecto Puede Estar Vacía";
                    BndError=true;
                    return false;
                }
                return true;
            });
            this.OpcionesEncuesta.every((element)=>{
                if (element.Nombre=='') {
                    Mensaje="Ninguna Opción de Encuesta Puede Estar Vacía";
                    BndError=true;
                    return false;
                }
                return true;
            });
            if (BndError) {
                this.$toast.warning(Mensaje);
                this.oBtnSave.DisableBtn=false;
                return false;
            }
            let formData=new FormData();
            formData.set('OpcionesDefault',JSON.stringify(this.OpcionesDefault));
            formData.set('OpcionesEncuesta',JSON.stringify(this.OpcionesEncuesta));
            await this.$http.post('configEncuestaOpcionesBase',formData
            ).then((res)=>{
                this.EjecutaConExito(res)
            }).catch((err)=>{
                this.EjecutaConError(err);
            })
        },
        EjecutaConExito(res){
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err){
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.$http.get("configEncuestaOpcionesBaseRecovery",{
                params:{
                    Anio:this.pAnio,
                    Idioma:this.pIdioma,
                    Categoria:this.pCategoria
                }
            }).then((res)=>{
                this.IniciarMostrarBoton(res.data.data.OpcionesDefault);
                this.IniciarMostrarBoton(res.data.data.OpcionesEncuesta);
                this.OpcionesDefault=res.data.data.OpcionesDefault;
                this.OpcionesEncuesta=res.data.data.OpcionesEncuesta;
                this.BloquearEdicion=res.data.data.BloquearEdicion;
                this.oBtnSave.DisableBtn=res.data.data.BloquearEdicion;
                this.oBtnSave.ShowSpinner=false;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        Limpiar(){

        },
        Regresar(){
            this.$router.push({name:'opcionencuesta'});
        },
        IniciarMostrarBoton(ArrayEnviado){
            ArrayEnviado.forEach((element)=>{
                // element.MostrarBorrar=true;
                element.MostrarAdvertencia=true;
            })
        },
        AgregarOpcion(Camino){
            let objConfigEncuestaOpcionBase={
                IdConfigEncuestaOpcionBase:0,
                Nombre:'',
                Anio:this.pAnio,
                Idioma:this.pIdioma,
                Tipo:'',
                Categoria:this.pCategoria,
                MostrarBorrar:true,
                MostrarAdvertencia:false
            };
            switch (Camino) {
                case "opcion":
                    objConfigEncuestaOpcionBase.Tipo="opcion";
                    this.OpcionesDefault.push(objConfigEncuestaOpcionBase);
                    break;
            
                case "encuesta":
                    objConfigEncuestaOpcionBase.Tipo="encuesta";
                    this.OpcionesEncuesta.push(objConfigEncuestaOpcionBase);
                    break;
            }
        },
        EliminarOpcion(index,NombreArray){
            switch (NombreArray) {
                case 'Default':
                    if (this.OpcionesDefault[index].MostrarAdvertencia) {
                        this.$swal(Configs.configEliminar).then((result) =>
                        {
                            if(result.value)
                            {
                                this.$http.delete('configEncuestaOpcionesBase/'+this.OpcionesDefault[index].IdConfigEncuestaOpcionBase
                                ).then((res)=>{
                                    this.$swal(Configs.configEliminarConfirm);
                                    this.OpcionesDefault.splice(index,1);
                                })
                            } 
                        });
                    }
                    else{
                        this.OpcionesDefault.splice(index,1);
                    }
                    break;
                case 'Encuesta':
                if (this.OpcionesEncuesta[index].MostrarAdvertencia) {
                        this.$swal(Configs.configEliminar).then((result) =>
                        {
                            if(result.value)
                            {
                                this.$http.delete('configEncuestaOpcionesBase/'+this.OpcionesEncuesta[index].IdConfigEncuestaOpcionBase
                                ).then((res)=>{
                                    this.$swal(Configs.configEliminarConfirm);
                                    this.OpcionesEncuesta.splice(index,1);
                                })
                            } 
                        });
                    }
                    else{
                        this.OpcionesEncuesta.splice(index,1);
                    }
                    break;
            }
        }
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted() {
        this.oBtnSave.DisableBtn = false;
        this.Limpiar();
        if(this.Id!='') 
        {
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}
        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>